// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"551a9b52","481":"a5fee31a"}[chunkId] + ".chunk.css";
};